<div>
  <div class="font-weight-bold">
    {{ 'public.profile.loyaltyPointsTransactions' | translate }}
  </div>

  <!-- Desktop view -->
  <div class="d-none d-md-block innerTable pb-2">
    <table class="table table-responsive-sm">
      <thead>
      <tr>
        <th scope="col" class="pl-0">{{ 'public.profile.loyaltyOrderID' | translate }}</th>
        <th scope="col">{{ 'public.profile.loyaltyAmountPaid' | translate }}</th>
        <th scope="col">{{ 'public.profile.loyaltyPointsCollected' | translate }}</th>
        <th class="md">{{ 'public.profile.loyaltyRewardCollected' | translate }}</th>
        <th class="md">{{ 'public.profile.loyaltyAmountRedeemed' | translate }}</th>
        <th class="md">{{ 'public.global.date' | translate }}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let transaction of loyaltyTrasactions">
        <td class="pl-0">{{ transaction?.orderToken }}</td>
        <td>
          {{
            transaction?.discountedAmountSpent ?? 0 |
              formatPrice:getLocale():selectedStoreCurrency:selectedStoreCurrencySymbol
          }}
        </td>
        <td>{{ transaction?.amountCollected ?? 0 }}</td>
        <td>
          {{
            transaction?.amountRewardCollected ?? 0 |
              formatPrice:getLocale():selectedStoreCurrency:selectedStoreCurrencySymbol
          }}
        </td>
        <td class="md">
          {{
            transaction?.amountRedeemed ?? 0 |
              formatPrice:getLocale():selectedStoreCurrency:selectedStoreCurrencySymbol
          }}
        </td>
        <td class="md">
          {{ transaction?.createdAt | formattedTime: selectedStore?.settings?.TIME_FORMAT_SELECTION : getLocale() }}
          -
          {{ transaction?.createdAt | localizedDate:'ddd DD MMM YYYY' : getLocale() : getTimeZone() | async }}
        </td>
      </tr>
      </tbody>
    </table>

  </div>

  <!-- Mobile view -->
  <div class="d-block d-md-none innerUl">
    <ng-container *ngIf="!loyaltyTrasactions.length">
      <ul class="list-group loyalty-ul-list list-group-flush">
        <li class="d-flex pl-2 d-flex">
          {{ 'admin.global.noData'|translate }}
        </li>
      </ul>
    </ng-container>

    <ng-container *ngFor="let transaction of loyaltyTrasactions">
      <ul class="list-group loyalty-ul-list list-group-flush py-4">
        <li class="row">
          <div class="col-6">{{ 'public.profile.loyaltyOrderID' | translate }}</div>
          <div class="col-6">{{ transaction?.orderToken }}</div>
        </li>
        <li class="row">
          <div class="col-6">{{ 'public.profile.loyaltyAmountPaid' | translate }}</div>
          <div class="col-6">
            {{
              transaction?.discountedAmountSpent ?? 0 |
                formatPrice:getLocale():selectedStoreCurrency:selectedStoreCurrencySymbol
            }}
          </div>
        </li>
        <li class="row">
          <div class="col-6">{{ 'public.profile.loyaltyPointsCollected' | translate }}</div>
          <div class="col-6">{{ transaction?.amountCollected ?? 0 }}</div>
        </li>
        <li class="row">
          <div class="col-6">{{ 'public.profile.loyaltyRewardCollected' | translate }}</div>
          <div class="col-6">
            {{
              transaction?.amountRewardCollected ?? 0 |
                formatPrice:getLocale():selectedStoreCurrency:selectedStoreCurrencySymbol
            }}
          </div>
        </li>
        <li class="row">
          <div class="col-6">{{ 'public.profile.loyaltyAmountRedeemed' | translate }}</div>
          <div class="col-6">
            {{
              transaction?.amountRedeemed ?? 0 |
                formatPrice:getLocale():selectedStoreCurrency:selectedStoreCurrencySymbol
            }}
          </div>
        </li>
        <li class="row">
          <div class="col-6">{{ 'public.global.date' | translate }}</div>
          <div class="col-6">
            {{ transaction?.createdAt | formattedTime: selectedStore?.settings?.TIME_FORMAT_SELECTION : getLocale() }}
            -
            {{ transaction?.createdAt | localizedDate:'ddd DD MMM YYYY' : getLocale() : getTimeZone() | async }}
          </div>
        </li>

      </ul>

    </ng-container>
  </div>
  <app-pager [totalPagesCount]="transactionsPage?.totalPages"
             [page]="transactionsPage?.number"
             [size]="transactionsPage?.size"
             [variant]="'theme'"
             (paginate)="paginate($event)">
  </app-pager>
</div>
<app-loading-panel [showLoading]="status=='LOADING'" [hideText]="true" [isSmall]="true" [overlay]="true">
</app-loading-panel>
